export default {
  data: {
    color: '#7A7E83',
    selectedColor: '#00a0ff',
    list: [{
      pagePath: '/homeCatalog?',
      iconPath: 'https://near.us-msc.com/data/xcx_pic/index/tab11.png',
      selectedIconPath: 'https://near.us-msc.com/data/xcx_pic/index/tab1.png',
      icon: 'icon-061',
      text: '首页',
    },
    {
      pagePath: '/searchCatalog/index?',
      iconPath: 'https://near.us-msc.com/data/xcx_pic/index/tab22.png',
      selectedIconPath: 'https://near.us-msc.com/data/xcx_pic/index/tab2.png',
      icon: 'icon-062',
      text: '搜索',
    },
    {
      pagePath: '/contactCatalog/index?',
      iconPath: 'https://near.us-msc.com/data/xcx_pic/index/tab44.png',
      selectedIconPath: 'https://near.us-msc.com/data/xcx_pic/index/tab4.png',
      icon: 'icon-063',
      text: '联系',
    },
    ],
  },
  userInfo: null,
  attribute: null, // 页面属性传递
  loginInfo: {
    album_alias: '',
    token: '',
  },
  openid: null,
  version: '1.0.2',
  model: '',
  myshow: false,
}
